import React from "react";

/** Page chrome shared by the account-deletion pages (public, no app shell). */
export default function DeletionShell({
  children,
  maxWidth = "720px",
}: {
  children: React.ReactNode;
  maxWidth?: string;
}): React.JSX.Element {
  return (
    <div
      style={{
        minHeight: "100dvh",
        background: "var(--c-cream)",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "var(--s-7) var(--gutter)",
      }}
    >
      <div className="stack-5" style={{ width: "100%", maxWidth }}>
        <div style={{ display: "flex", justifyContent: "flex-end", padding: "0 var(--s-1)" }}>
          <a href="/" className="logo" aria-label="kivo.skin home">
            kivo<span className="dot" />
          </a>
        </div>
        <div className="card card--bordered">{children}</div>
      </div>
    </div>
  );
}

/** "27 October 2026" — the deletion date, in the visitor's locale. */
export function formatDeletionDate(iso?: string): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" });
}

/** "14 days" / "1 day" / "less than a day". */
export function formatDaysLeft(days: number): string {
  if (days <= 0) return "less than a day";
  return days === 1 ? "1 day" : `${days} days`;
}
